import React from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, Media } from 'reactstrap';

class SolutionsMenu extends React.Component {

    render() {
        return <UncontrolledDropdown nav>
        <DropdownToggle nav>
          <i className="ni ni-diamond d-lg-none mr-1" />
          <span className="nav-link-inner--text">Solutions/APIs</span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-xl">
          <div className="dropdown-menu-inner">
            <Media className="d-flex align-items-center"  href="solutions/notifications" >
              <div className="icon icon-shape bg-gradient-success rounded-circle text-white">
                <i className="ni ni-notification-70" />
              </div>
              <Media body className="ml-3">
                <h6 className="heading text-success mb-md-1">
                  Notifications/Communication
                </h6>
                <p className="description d-none d-md-inline-block mb-0">
                  Solutions to interact with your clients via SMS, WhatsApp, Push Notifications, Voice messages and many more
                </p>
              </Media>
            </Media>
            <Media className="d-flex align-items-center"  href="solutions/payments" >
              <div className="icon icon-shape bg-gradient-info rounded-circle text-white">
                <i className="ni ni-money-coins" />
              </div>
              <Media body className="ml-3">
                <h6 className="heading text-info mb-md-1">
                  Payment
                </h6>
                <p className="description d-none d-md-inline-block mb-0">
                  Make and receive payments to and from various channels including Mobile Money, Card and many more
                </p>
              </Media>
            </Media>
          </div>
        </DropdownMenu>
      </UncontrolledDropdown>
      ;
    }
}

export default SolutionsMenu;